<template>
    <div class="full-width" ref="sendRecordDom" v-loading="loading">
        <div>
            <img :class="refWidth > 768 ? 'card-img' : 'card-img-mobile'" :src="imgUrl" />
        </div>

        <div :class="refWidth > 768 ? 'operation-box' : 'operation-box-mobile'">
            <div>
                <el-button type="success" @click="passRecord"><font-awesome-icon icon="fa-solid fa-check" />&nbsp;通過並添加</el-button>
            </div>

            <div :class="refWidth > 768 ? 'delete-btn' : 'delete-btn-mobile'">
                <el-button type="danger" @click="delRecord"><font-awesome-icon icon="fa-regular fa-trash-can" />&nbsp;刪除</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed, toRef} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import record1Api from "@/request/record1Api"
    import myUtil from "@/util/util"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCheck } from '@fortawesome/free-solid-svg-icons'
    import { faTrashCan } from '@fortawesome/free-regular-svg-icons'

    library.add(faCheck, faTrashCan)

    const props = defineProps(['record'])
    const emits = defineEmits(['passRecord', 'delRecord'])

    const { proxy } = getCurrentInstance();

    const userinfoRef = toRef(useUserinfo())

    const loading = ref(false)

    const refWidth = ref(425)
    const imgUrl = computed(() => {
        if (null == props.record){
            return null
        }

        return myUtil.generateCardImgUrl(props.record.cardinfo)
    })

    function passRecord(){
        loading.value = true

        const request = record1Api.assentRecord1
        const params = request.getParams()
        params.id = props.record.record1Id
        params.mssqlno = userinfoRef.value.token

        request.send(
            params,
            (res) => {
                if (res.code == 200){
                    myUtil.alertSuccess("已通過請求")
                    emits("passRecord", props.record.record1Id)
                }else{
                    myUtil.alertError(res.msg)
                }
            }
        )
    }

    function delRecord(){
        myUtil.confirmWarning(
            "確定刪除嗎？",
            () => {
                loading.value = true

                const request = record1Api.delRecord1
                const params = request.getParams()
                params.id = props.record.record1Id

                request.send(
                    params,
                    (res) => {
                        loading.value = false
                        if (res.code == 200){
                            myUtil.alertSuccess("刪除成功")
                            emits("delRecord", props.record.record1Id)
                        }else{
                            myUtil.alertError(res.msg)
                        }
                    }
                )
            }
        )
    }

    onMounted(() => {
        refWidth.value = proxy.$refs.sendRecordDom.offsetWidth
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
        display: flex;
        padding-top: 15px;
        padding-bottom: 15px;
        align-items: center;
        justify-content: space-around;
        border-bottom: 1px solid #e5e5e5;
        flex-wrap: wrap;
    }

    .card-img {
        width: 425px;
        height: 275px;
        object-fit: scale-down;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
    }

    .card-img-mobile {
        width: 100%;
        object-fit: scale-down;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
    }

    .delete-btn {
        margin-top: 20px;
    }

    .delete-btn-mobile {
        margin-left: 20px;
    }

    .operation-box {

    }

    .operation-box-mobile {
        display: flex;
        margin-top: 20px;
    }

</style>